import MaintenanceContainer from "../../../../Components/OtherPages/Authentication/Maintenance/Maintenance"

const Maintenance = () => {
  return (
    <div className='page-body'>
      <MaintenanceContainer />
    </div>
  )
}

export default Maintenance